/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientCompanyViewModel } from '../../models/client-company-view-model';

export interface GetClientCompanies$Params {
  clientID: number;
}

export function GetClientCompanies(http: HttpClient, rootUrl: string, params: GetClientCompanies$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientCompanyViewModel>>> {
  const rb = new RequestBuilder(rootUrl, GetClientCompanies.PATH, 'post');
  if (params) {
    rb.path('clientID', params.clientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ClientCompanyViewModel>>;
    })
  );
}

GetClientCompanies.PATH = '/api/Clients/GetClientCompanies/{clientID}';
